/*globals ga:true */

angular.module('b2bRegistrationFlowBundle').controller('stepController', ["$rootScope", "$scope", "$http", "multiStepFormInstance", "TranslationService", "$timeout", "sdLocalStorageHelper", "$anchorScroll", "$window", function ($rootScope, $scope, $http, multiStepFormInstance, TranslationService, $timeout, sdLocalStorageHelper, $anchorScroll, $window) {
    sdLocalStorageHelper.get('referralDetails', $scope.data);

    $scope.stepControllers = {};
    $scope.wentBack = false;
    $scope.registerStepController = function(index, ctrlScope) {
        $scope.stepControllers[index] = ctrlScope;
    };

    $scope.onProgressBarClick = function (index, step) {
        if (multiStepFormInstance.getActiveIndex() > index) {
            sendFormInteractionEvent('return');
            multiStepFormInstance.setActiveIndex(step);
        }
    }

    $scope.completedSteps = {};
    sdLocalStorageHelper.get('b2bFormCompletedSteps', $scope.completedSteps);
    $scope.$watchCollection('completedSteps', function () {
        sdLocalStorageHelper.set('b2bFormCompletedSteps', $scope.completedSteps);
    });

    $timeout(function () {
        activate();
    }, 1);

    function activate() {
        switchToPreviousNotVisitedStep();
        subscribeGAStepTrackChange();
    }

    $scope.isStepValid = function () {
        return (!multiStepFormInstance.getActiveStep().hasForm || multiStepFormInstance.getActiveStep().valid);
    };

    function markCurrentStepsAsCompleted() {
        const currentStep = multiStepFormInstance.getActiveStep();
        $scope.completedSteps[currentStep.title] = true;
    }

    $scope.progress = function () {
        $scope.wentBack = false;
        multiStepFormInstance.getActiveStep().submitted = true

        if ($scope.formStatus.pending) {
            $scope.formStatus.submitting = true;
            var unwatch = $scope.$watch('formStatus.pending', function (pending) {
                if (!pending) {
                    unwatch();
                    $scope.formStatus.submitting = false;
                    $scope.progress();
                }
            });
            return;
        }

        if (!$scope.isStepValid()) {
            sendFormInteractionEvent('error');
            scrollToInvalidQuestion();
            return;
        }

        if ($scope.stepControllers[multiStepFormInstance.getActiveIndex()].nicheAutoAcceptModalSite) {
            $scope.stepControllers[multiStepFormInstance.getActiveIndex()].showNicheAutoAcceptDialog()
            return;
        }

        sendFormInteractionEvent('submit');

        markCurrentStepsAsCompleted();
        if (multiStepFormInstance.isLast()) {
            $scope.submitCompanyRegistration();
            return;
        }
        multiStepFormInstance.nextStep();
    };

    $scope.goToPreviousStep = function () {
        sendFormInteractionEvent('return');
        $scope.wentBack = true;

        multiStepFormInstance.previousStep();
    }

    function sendFormInteractionEvent(interactionType) {
        try {

            if (!['submit', 'return', 'view', 'error'].includes(interactionType)) {
                console.error('Error sending form interaction event: Invalid interaction type: ' + interactionType);

                return;
            }

            let gaFormInteractionData = getFormInteractionDataLayerObject(interactionType);
            const ctrl = $scope.stepControllers[multiStepFormInstance.getActiveIndex()];
            if (['submit', 'error'].includes(interactionType)) {
                gaFormInteractionData.form_value = ctrl.getGAFormData()
            }

            if (['error'].includes(interactionType)) {
                gaFormInteractionData.error_data = ctrl.getGAFormErrorData()
            }

            $window.dataLayer = $window.dataLayer || [];
            $window.dataLayer.push(gaFormInteractionData);

            if (window.localStorage.getItem('ga-debug')) {
                console.info('GA event pushed:', gaFormInteractionData);
            }

        } catch (e) {
            console.error('Error sending form interaction event: ', e);
        }
    }

    function getFormInteractionDataLayerObject(interactionType) {
        const formIdElement = document.body.querySelector('[data-b2b-form-authcode]');
        const formId = formIdElement ? formIdElement.getAttribute('data-b2b-form-authcode') : null;
        let data = {
            event: 'form_interaction',
            form_id: formId,
            form_name: 'business_registration',
            form_interaction: interactionType,
            form_step: multiStepFormInstance.getActiveIndex(),
            form_step_name: multiStepFormInstance.getActiveStep().title,
            form_total_steps: multiStepFormInstance.getSteps().length,
        };

        let abVersion  = document.body.getAttribute('data-ab');
        if (abVersion) {
            data.ab_test_variant = abVersion;
        }

        return data;
    }

    function scrollToInvalidQuestion()
    {
        let scrollElement = null;

        const invalidQuestions = Array.from(
            document.querySelectorAll(
                'input.ng-invalid, select.ng-invalid, textarea.ng-invalid, input.ng-pending'
            )
        ).filter(el => el.offsetParent !== null); // visible check

        if (invalidQuestions.length > 0) {
            const firstInvalidQuestion = invalidQuestions[0];

            const formGroup = firstInvalidQuestion.closest('.form-group');

            if (formGroup) {
                scrollElement = formGroup;
            } else {
                scrollElement = firstInvalidQuestion;
            }
        }

        if (scrollElement) {
            scrollElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    $scope.getCurrentStep = function () {
        return multiStepFormInstance.activeIndex;
    }

    $scope.getStepsNumbers = function () {
        return Array.from(Array(multiStepFormInstance.steps.length).keys());
    }

    $scope.getNextStepName = function () {
        return multiStepFormInstance.isLast() ? null : multiStepFormInstance.getSteps()[multiStepFormInstance.getActiveIndex()].title;
    };

    $scope.getPreviousStepName = function () {
        return multiStepFormInstance.isFirst() ? null : multiStepFormInstance.getSteps()[multiStepFormInstance.getActiveIndex() - 2].title;
    };

    $scope.stepChange = function () {
        $scope.scrollToTop();
        sendFormInteractionEvent('view');
    };

    $scope.scrollToTop = function () {
        var formStep = document.getElementsByClassName('form-step')[0];

        if (typeof formStep !== 'undefined') {
            window.scrollTo(0, formStep.offsetTop);
        }
    };

    $scope.onStepChange = function () {
        $rootScope.activeIndex = multiStepFormInstance.getActiveIndex();
        $anchorScroll('registration-header');

        sendFormInteractionEvent('view');
    };

    function subscribeGAStepTrackChange() {
        // that is not done inside of stepChange() to not send an event on the initial controller loading
        multiStepFormInstance.deferred.promise.then(null, null, function (state) {
            if (angular.isDefined(state.newStep)) {
                $timeout(function () {
                    if (typeof ga !== 'undefined' && typeof ga.getAll === 'function') {
                        var trackers = ga.getAll();
                        for (var key in trackers) {
                            trackers[key].send('pageview', {'location': window.location.href});
                        }
                    }
                }, 10);
            }
        });
    }

    function switchToPreviousNotVisitedStep() {
        checkHomedealToNicheRedirection()
        const currentIndex = multiStepFormInstance.getActiveIndex();

        // iterate over multiStepFormInstance.getSteps(), and if any step before the current one is not completed,
        // call multiStepFormInstance.setActiveIndex with the index and stop loop
        // Step is completed if title is resent in the completedSteps
        for (let i = 0; i < currentIndex; i++) {
            let step = multiStepFormInstance.getSteps()[i];
            if (typeof $scope.completedSteps[step.title] === 'undefined') {
                multiStepFormInstance.setActiveIndex(i+1); // setActiveIndex is 1-based
                break;
            }
        }
    }

    function checkHomedealToNicheRedirection() {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;

        const b2bStepsRaw = searchParams.get('b2bFormCompletedSteps');
        const formDetailsRaw = searchParams.get('ngStorage-b2bFormDetails');

        if (b2bStepsRaw && formDetailsRaw) {
            try {
                const b2bSteps = JSON.parse(b2bStepsRaw);
                const formDetails = JSON.parse(formDetailsRaw);

                $scope.completedSteps = b2bSteps;

                Object.keys(formDetails).forEach(function(key) {
                    $scope.data[key] = formDetails[key];
                });

                sdLocalStorageHelper.set('b2bFormCompletedSteps', $scope.completedSteps);
                sdLocalStorageHelper.set('b2bFormDetails', $scope.data);

                searchParams.delete('b2bFormCompletedSteps');
                searchParams.delete('ngStorage-b2bFormDetails');

                const newUrl = `${url.origin}${url.pathname}${searchParams.toString() ? '?' + searchParams.toString() : ''}${url.hash}`;
                window.history.replaceState(null, '', newUrl);
            } catch (e) {
                console.error('Failed to parse b2b form data from URL:', e);
            }
        }
    }
}]);
